import React from 'react';

import { Title, Spacing } from '@vkontakte/vkui';

import styles from './index.module.css';
import { FamousPersonsProps } from './types';
import { FamousPerson } from '../../../components/FamousPerson';

export const FamousPersons:React.FC<FamousPersonsProps> = ({ temperamentData }) => {
  return (
    <div>
      <div style={{ margin: '0 26px' }}>
        <Title level="2" style={{ fontWeight: 700 }}>
                    Знаменитые представители
        </Title>
      </div>
      <Spacing size={16} />
      <div className={styles.famousPersonsContainer}>
        {temperamentData.famousPersons.map(({ image, name, subtitle, smallImage }: any) => {
          return (
            <div className={styles.famousPersonsCellContainer}>
              <FamousPerson
                image={image}
                name={name}
                subtitle={subtitle}
                smallImage={smallImage}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
